module.exports = __webpack_public_path__ + "static/img/weboar_logo_white.fdf8910.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/weboar_logo_white.png
// module id = aM3B
// module chunks = 1